import {
    ADDED,
    DELETED,
    FETCHED_ALL,
    LOADED_FORM_DATA,
    UPDATED,
} from "./actionTypes";
import initialState from "./initialState";

const nextBookId = (books) => {
    const maxId = books.reduce((maxId, book) => Math.max(book.id, maxId), -1);
    return maxId + 1;
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCHED_ALL:
            return {
                ...state,
                books: action.payload
            };

        case ADDED:
            const { name, author, thumbnail, price, rating, featured } = action.payload;
            return {
                ...state,
                books: [
                    ...state.books,
                    {
                        id: nextBookId(state.books),
                        name,
                        author,
                        thumbnail,
                        price,
                        rating,
                        featured
                    }
                ]
            };

        case UPDATED:
            const { bookId, data } = action.payload;
            const books = state.books.map((book) => {
                if (book.id !== bookId) {
                    return book;
                }
                return {
                    ...data
                };
            });
            return {
                ...state,
                book: {},
                books: books
            }

        case LOADED_FORM_DATA:
            return {
                book: action.payload,
                books: [...state.books]
            }

        case DELETED:
            const booksAfterDelete = state.books.filter((book) => book.id !== action.payload);
            return {
                ...state,
                books: booksAfterDelete
            }

        default:
            return state;
    }
};

export default reducer;
